import { basicMsg, msg as swalMsg } from "../../swal_msg";
import { protectedFetchReq, protectedReq } from "../../../helpers/requestHelper";

// obtener formularios de contacto
export const getContactForms = async(setForms, setLoading) => {
    try {
        const resp = await protectedReq('form/contact/get');
        const body = await resp.json();
        if (body.status)
            setForms(body.resp);
        else {
            if (body.msg === 'server-err')
                swalMsg('error', 'Contacto',
                'Ocurrió un incidente al cargar información de contacto');
        }
        setLoading(false);
    } catch (err) {
        swalMsg('error', 'Contacto',
        'Ocurrió un incidente. Intente de nuevo, por favor');
        setLoading(false);
    };
};

// enviar respuesta a contacto
export const replyEmail = async(model, setLoading, dispatch) => {
    try {
        const body = await protectedFetchReq('form/contact/reply', model, 'POST', dispatch);
        if (body) {
            const { status, msg } = body;
            if (!status) {
                if (msg === 'miss')
                    basicMsg('Falta información del contacto');
                else if (msg === 'email-not-send')
                    swalMsg('info', 'Contacto',
                    'No se pudo enviar la respuesta');
                else if (msg === 'contact-not-found')
                    swalMsg('No se encontró el contacto a responder');
                else if (msg === 'server-err')
                    swalMsg('error', 'Contacto',
                    'Ocurrió un incidente al responder correo');
                else
                    swalMsg('warning', 'Contacto',
                    'Inténtelo de nuevo, por favor');
            }
            setLoading(false);
            return { status };
        }
        return { status: false };
    } catch (err) {
        setLoading(false);
        swalMsg('error', 'Contacto',
        'No se pudo enviar el correo electrónico');
        return { status: false };
    };
};